/** Decodifica entidades HTML (ex.: `&#231;` → `ç`) sem usar `dangerouslySetInnerHTML` — o retorno é só texto. */
export function decodeHtmlEntities(value: string): string {
  const parsed = new DOMParser().parseFromString(value, 'text/html');
  return parsed.documentElement.textContent ?? '';
}
